import { render, staticRenderFns } from "./OrderSetting.vue?vue&type=template&id=f0a85bca&scoped=true"
import script from "./OrderSetting.vue?vue&type=script&lang=js"
export * from "./OrderSetting.vue?vue&type=script&lang=js"
import style0 from "./OrderSetting.vue?vue&type=style&index=0&id=f0a85bca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a85bca",
  null
  
)

export default component.exports